import KindleSlides from '../Util/KindleSlides';
import { GoogleLogin } from '@react-oauth/google';
import { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode'
import Card from 'react-bootstrap/Card';
import { updateMetaTags } from '../script';

export default function Account(props) {
  const [user_profile, set_user_profile] = useState(null);
  const [profileEdit, setprofileEdit] = useState(false);
  const [isProUser, setIsProUser] = useState(false);  // New state for Pro user status


  let login_benefits = [
    "Get to the Point: 6hats provides mobile-friendly, bite-sized responses that get straight to the point. Simply type your query and explore six clear structured aspects of the topic.",
    "Insight Vault: For open-ended questions, 6hats automatically generates tailored questions and responses for instant exploration. Just press the <b>Wizard Hat</b> to dive deeper into your topic.",
    "One Query, Six Voices: Explore any topic with six diverse perspectives for a richer, multi-faceted understanding. Use the <b>One Query, Six Voices</b> slider to unlock these unique viewpoints.",
    "Share and Connect: Organize and share your queries and responses through personal Streams. Save discussions, set privacy levels, and invite others to explore with you.",
    "6hats Use Cases: Plan your next <b>trip</b>, handle day-to-day <b>challenges</b>, navigate <b>setbacks</b>, resolve <b>micro conflicts</b>, and much more.",
    "6hats Pro: <b>Source Streams</b> from PDFs for Sales or receive <b>certified responses</b> for therapy patients. Tailor 6hats for specialized, professional use cases."
  ];

  async function get_profile(email) {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/user_profile/${email}`);
      if (response.ok) {
        const responseData = await response.json();
        console.log("Profile data:", responseData);
        return responseData;
      } 
    } catch (error) {
      console.error('Error getting profile:', error);
      return false;
    }
  }

  async function create_profile(email) {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/user_profile`, {
        method: "POST",
        body: JSON.stringify({
          email: email,
          display_name: email.split("@")[0],
          full_name: "",
          bio: "",
          profile_picture: "",
          website: "",
          location: "",
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log(responseData)
        return responseData;
      } 
      else {
        const errorData = await response.json();
        console.error('Error creating profile:', errorData);
        return false;
      }
    } catch (error) {
      console.error('Error creating profile:', error);
      return false;
    }
  }

  async function update_profile() {
    let new_prof = user_profile;

    new_prof.display_name = document.getElementById("display-name").value;
  
    new_prof.full_name = document.getElementById("full-name").value;
    new_prof.bio = document.getElementById("user-bio").value;

    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/user_profile/${new_prof.email}`, {
        method: "PUT",
        body: JSON.stringify({
          email: new_prof.email,
          display_name: new_prof.display_name,
          full_name: new_prof.full_name,
          bio: new_prof.bio,
          profile_picture: "",
          website: "",
          location: "",
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        alert("Profile Updated")
        setprofileEdit(false)
        return responseData;
      } else {
        alert("Error: profile details not valid")
        return false;
      }
    } catch (error) {
      console.error('Error updating stream:', error);
      return false;
    }
  }

  const handleUpgrade = async () => {
    if (!user_profile || !user_profile.email) {
      console.error("User profile not found or email missing.");
      return;
    }
  
    // Check if the user is already a Pro user
    if (isProUser) {
      alert("You are already a 6hats Pro user.");
      return; // Prevent the upgrade attempt if already Pro
    }
  
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/user_profile/${user_profile.email}/upgrade`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });
  
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.message && responseData.message.includes("already a Pro user")) {
          alert("You are already a 6hats Pro user.");
        } else {
          setIsProUser(true);
          alert("Successfully upgraded to 6hats Pro!");
        }
      } else {
        console.error("Upgrade failed.");
        alert("Upgrade to Pro failed. Please try again.");
      }
    } catch (error) {
      console.error("Error upgrading user type:", error);
      alert("An error occurred while upgrading. Please try again.");
    }
  };
  

  const handleDowngrade = async () => {
    if (!user_profile || !user_profile.email) {
      console.error("User profile not found or email missing.");
      return;
    }
  
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/user_profile/${user_profile.email}/downgrade`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });
  
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.message && responseData.message.includes("downgraded")) {
          setIsProUser(false);  // Update the state to reflect the downgrade
          alert("Successfully downgraded to Basic.");
        } else {
          console.error("Downgrade failed.");
          alert("Downgrade failed. Please try again.");
        }
      } else {
        console.error("Downgrade failed.");
        alert("Downgrade failed. Please try again.");
      }
    } catch (error) {
      console.error("Error downgrading user type:", error);
      alert("An error occurred while downgrading. Please try again.");
    }
  };  
  
  async function getUserInfo(email) {
    console.log("getting user info");
  
    let prof = await get_profile(email);
    if (prof) {
      set_user_profile(prof);
      console.log("User type is ", prof.user_type);
      setIsProUser(prof.user_type && prof.user_type.toLowerCase() === 'pro');
    } else {
      console.log("failure - make profile");
      prof = await create_profile(email);
      if (prof) {
        window.location.reload();
      }
    }
  }  


  async function handleCredentialResponse(response) {
    // Decode the ID token and log the user details
    const data = jwtDecode(response.credential);
    localStorage.setItem("useremail", data.email);
    props.setLoggedInEmail(data.email);
    getUserInfo(data.email);
  }

  useEffect(() => {
    // Call the function whenever the page content changes
    updateMetaTags();
  
    if (props.loggedInEmail) {
      getUserInfo(props.loggedInEmail);
    }
  }, [props.loggedInEmail]);
  
  useEffect(() => {
    if (user_profile) {
      if (user_profile.display_name) {
        document.getElementById("display-name").value = user_profile.display_name
      }
  
      if (user_profile.full_name) {
        document.getElementById("full-name").value = user_profile.full_name
      }
  
      if (user_profile.bio) {
        document.getElementById("user-bio").value = user_profile.bio
      }
    }
  }, [user_profile]);
  

  return (
    <div className="content-div">
      <div style={{ position: "relative" }}>
        {!props.loggedInEmail ?
          <div style={{
            position: "absolute",
            display: "flex",
            justifyContent: "flex-end",
            padding: "10px",
            width: "100%",
            zIndex: "1000"
          }}>
            <GoogleLogin
              onSuccess={credentialResponse => {
                handleCredentialResponse(credentialResponse);
              }}
              onError={() => {
                console.log('Login Failed');
              }}
            />
          </div> : null}
        {!props.loggedInEmail && login_benefits.length > 0 ?
          <KindleSlides slides={login_benefits} />
          : null
        }

        {props.loggedInEmail && user_profile ?
          <div className="stream-view">
            <h3 id="title-field" style={{ marginInline: "50px" }}>User Profile</h3>
            <p> Logged in as {props.loggedInEmail}</p>
            <hr style={{ height: "4px", width: "100%" }} />
            <div id="table_items" className="stream-table">
              <Card>
                <div className={'stream-table-row dark-background'}>
                  <div className='table-left-quarter'>
                    <h6>Display Name:</h6>
                  </div>
                  <div className='stream-table-center'>
                    <textarea id="display-name" disabled={!profileEdit} className='no-resize-textarea' rows="1" placeholder="Enter a display name to be shown to other users" />
                  </div>
                </div>
              </Card>

              <Card>
                <div className={'stream-table-row'}>
                  <div className='table-left-quarter'>
                    <h6>Full Name:</h6>
                  </div>
                  <div className='stream-table-center'>
                    <textarea id="full-name" disabled={!profileEdit} className='no-resize-textarea' rows="1" placeholder="Enter your full name" />
                  </div>
                </div>
              </Card>

              <Card>
                <div className={'stream-table-row dark-background'}>
                  <div className='table-left-quarter'>
                    <h6>Bio:</h6>
                  </div>
                  <div className='stream-table-center'>
                    <textarea id="user-bio" disabled={!profileEdit} className='no-resize-textarea' rows="2" placeholder="Add a short biography to describe yourself to other users" />
                  </div>
                </div>
              </Card>

              <Card className="conspicuous-card-minimal" onClick={() => { 
                if (profileEdit){
                  update_profile();
                }else{
                  setprofileEdit(true);
                }
               }}>
                <div className="stream-table-row">
                  <div className="table-left">
                    {profileEdit ? 
                    <i className="fa-solid fa-save fa-lg"></i>: <i className="fa-solid fa-pencil fa-lg" style={{ color: "#fff" }}></i>}
                  </div>
                  <div className="stream-table-center">
                    <h6 style={{ color: "#fff" }}>{profileEdit ?  "Save changes" : "Edit Profile"}</h6>
                  </div>
                </div>
              </Card>
                {!isProUser ? (
                  <Card className="conspicuous-card-minimal" onClick={handleUpgrade}>
                    <div className="stream-table-row" style={{ backgroundColor: "#BA7E2B" }}>
                      <div className="table-left">
                        <i className="fa-solid fa-crown fa-lg"style={{ color: "#fff" }}></i>
                      </div>
                      <div className="stream-table-center">
                        <h6 style={{ color: "#fff" }}>Upgrade to 6hats Pro Free (until 7th April 2025)</h6>
                      </div>
                    </div>
                  </Card>
                ) : (
                  <>
                    <Card className="conspicuous-card-minimal" onClick={handleDowngrade}>
                      <div className="stream-table-row" style={{ backgroundColor: "#6c7416" }}>
                        <div className="table-left">
                          <i className="fa-solid fa-arrow-down fa-lg" style={{ color: "#fff" }}></i> {/* White icon */}
                        </div>
                        <div className="stream-table-center">
                          <h6 style={{ color: "#fff" }}>Downgrade to Basic</h6> {/* White text */}
                        </div>
                      </div>
                    </Card>
                  </>
                )}
            </div>
          </div> : null}
      </div>
    </div>
  );
}